(function(window, angular, undefined) {
    var app = angular.module('formApp');
    app.directive("anzValidate", [function() {
        return {
            restrict: "A",
            require: '?ngModel',
            scope: {
                anzValidateConstraints: "="
            },
            link: function($scope, element, attrs, ctrl) {
                if (typeof $scope.anzValidateConstraints !== 'undefined') {
                    
                    $scope.anzValidateConstraints.forEach(function(constraint) {
                        if (constraint.type === "pattern") {
                            ctrl.$validators.pattern = function(modelValue) {
                                return ctrl.$isEmpty(modelValue) || new RegExp(constraint.value).test(modelValue);
                            };
                        }
                        if (constraint.type === "businessRestrictPattern") {
                            ctrl.$validators.restriction = function(modelValue) {
                                return ctrl.$isEmpty(modelValue) || !new RegExp(constraint.value).test(modelValue);
                            };
                        }
                        if (constraint.type === "length") {
                            if (constraint.min) {
                                ctrl.$validators.minlength = function(modelValue) {
                                    return ctrl.$isEmpty(modelValue) || parseInt(modelValue.length) >= parseInt(constraint.min);
                                };
                            }
                            if (constraint.max) {
                                ctrl.$validators.maxlength = function(modelValue) {
                                    return ctrl.$isEmpty(modelValue) || parseInt(modelValue.length) <= parseInt(constraint.max);
                                };
                            }
                        }
                    });
                }                                                                                                                        
            }
        };
    }]);
})(window, window.angular);